// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"7215":"9afe624927c5e8d8","24329":"8123982dc5440142","49605":"589d8a59a4be3154"}[chunkId] + ".css";
};